import React, { useEffect, useState } from "react";
import Chart from 'chart.js';

const LineChart = (props) => {

  useEffect(() => {
    displayChart();
  }, [props.data]);

  const displayChart = () => {
    const node = document.getElementById(props.id);
    let teamPerformanceChart = new Chart(node, {
      type: 'line',
      data: props.data,
      options: {
        legend: {
          position: "bottom",
          align: "start",
          labels: {
            usePointStyle: true,
            fontSize: 15,
            padding: 30
          }
        },
        elements: {
          line: {
            tension: 0
          }
        },
      }
    });
    props.setTeamPerformanceChart(teamPerformanceChart);    
  }
  return (
    <div>
      <canvas
        className={props.line}
        id={props.id}
      />
    </div>
  )
}

export default LineChart;
